module.exports = __webpack_public_path__ + "static/img/mo2.c69f096.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/control2/mo2.png
// module id = PTs6
// module chunks = 7